import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import ScrollToTop from "@/components/layout/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Departments, { DepartmentDetail } from "@/pages/Departments";
import Doctors, { DoctorDetail } from "@/pages/Doctors";
import Blog, { BlogPostPage } from "@/pages/Blog";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminDoctors from "@/pages/admin/AdminDoctors";
import AdminDepartments from "@/pages/admin/AdminDepartments";
import AdminServices from "@/pages/admin/AdminServices";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminFacilities from "@/pages/admin/AdminFacilities";
import AdminHomeSections from "@/pages/admin/AdminHomeSections";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminSite from "@/pages/admin/AdminSite";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/departments/:slug" element={<DepartmentDetail />} />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/doctors/:id" element={<DoctorDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="doctors" element={<AdminDoctors />} />
            <Route path="departments" element={<AdminDepartments />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="home-sections" element={<AdminHomeSections />} />
            <Route path="facilities" element={<AdminFacilities />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="site" element={<AdminSite />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
